import { render, staticRenderFns } from "./btbList.vue?vue&type=template&id=96d31c84&scoped=true"
import script from "./btbList.vue?vue&type=script&lang=js"
export * from "./btbList.vue?vue&type=script&lang=js"
import style0 from "./btbList.vue?vue&type=style&index=0&id=96d31c84&prod&lang=css"
import style1 from "./btbList.vue?vue&type=style&index=1&id=96d31c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d31c84",
  null
  
)

export default component.exports